import { DateTime } from 'luxon';

// For the more common formatting options, see luxon's presets:
// See: https://moment.github.io/luxon/#/formatting?id=presets

export const TIME_SIMPLE = 'h:mm p';
export const TIME_SIMPLE_WITHOUT_AM_PM = 'h:mm';
export const TIME_AM_PM_ONLY = 'a';
export const DATETIME_HUGE_WITHOUT_TIMEZONE = 'cccc, LLLL d, yyyy';
export const TIMEZONE_SHORT_NAMED_OFFSET = 'ZZZZ';
export const TIMEZONE_LONG_NAMED_OFFSET = 'ZZZZZ';

export const formatToAMOrPM = (date: DateTime): string =>
  date.toFormat(TIME_AM_PM_ONLY);

export const getTimezoneString = (): string => {
  const currentTime = DateTime.now();
  return `${currentTime.toFormat(
    TIMEZONE_LONG_NAMED_OFFSET
  )} (${currentTime.toFormat(TIMEZONE_SHORT_NAMED_OFFSET)})`;
};
